import { toastr } from 'react-redux-toastr';
import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAddWhsDocumentsModal } from './addWhsDocumentsModal';

export const TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS = 'TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS';

function requestAddWhsDocuments() {
  return {
    type: TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS,
    isSubmittingAddWhsDocuments: true
  };
}

function successAddWhsDocuments() {
  return {
    type: TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS,
    isSubmittingAddWhsDocuments: false,
  };
}

function rejectAddWhsDocuments() {
  return {
    type: TOGGLE_IS_SUBMITTING_WHS_DOCUMENTS,
    isSubmittingAddWhsDocuments: false,
  };
}

export function submitAddWhsDocuments(accountId, uploadedDocuments) {
  return (dispatch) => {
    dispatch(requestAddWhsDocuments());

    const promise = () => ApiService
      .submitAddWhsDocuments(accountId, uploadedDocuments)
      .then((response) => {
        toastr.success('Upload Success', 'The documents have been successfully uploaded.');
        dispatch(hideAddWhsDocumentsModal());
        return dispatch(successAddWhsDocuments());
      })
      .catch((error) => {
        if (error.response) {
          toastr.error('Upload Error', 'There was an error uploading the documents.');
          dispatch(handleException(error, rejectAddWhsDocuments));
        } else {
          error.errorMessage = 'There was a problem communicating with the server. Please check the status of your uploaded document.';
          toastr.error('Upload Error', error.errorMessage);
          dispatch(handleException(error, rejectAddWhsDocuments));
        }
      });
    return promise();
  };
}
